import './App.css'
import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import LeadMagnet from './components/landingpage';
import Impressum from './components/impressum'; // Beachte den Großbuchstaben
import Datenschutz from './components/termsofservice'; // Datenschutz-Komponente

class App extends Component {
    state = {  } 

    render() { 
        return (
            <React.Fragment>
                <Router>

                    {/* Routen und ihre Komponenten */}
                    <Routes>
                        <Route path="/" element={<LeadMagnet />} /> 
                        <Route path="/Impressum" element={<Impressum />} />
                        {/*
                        <Route path="/Datenschutz" element={<Datenschutz />} />
                        */}
                    </Routes>

                    {/* Navigationsleiste unterhalb der Seite */}
                    <nav>
                        <Link to="/">Home</Link>
                        <Link to="/Impressum">Impressum</Link>
                        {/*
                        <Link to="/Datenschutz">Datenschutz</Link>
                        */}
                    </nav>

                </Router>      
            </React.Fragment>
        );
    }
}
 
export default App;
